import React from 'react';
import {useGoogleLogin} from '@react-oauth/google';
import Icon from "../../../@core/components/icon";
import {HttpAuth} from "../../../http/user/httpAuth";
import {AuthorizationResponse,} from "../../../types/user/authData";
import useAxios from "../../../hooks/useAxios";
import {useNavigate} from "react-router-dom";
import {Button} from "@mui/material";

interface GoogleSignInButtonProps {
    onLoginResponse: (response: AuthorizationResponse) => void,
}

const GoogleSignInButton = ({onLoginResponse}: GoogleSignInButtonProps) => {
    const {fetchData} = useAxios<AuthorizationResponse>();
    const navigate = useNavigate();

    const login = useGoogleLogin({
        flow: 'auth-code',
        onSuccess: tokenResponse => {

            fetchData(
                () => HttpAuth.authenticateWithGoogle({token: tokenResponse.code}),
                true
            )
                .then(onLoginResponse);
        },
    });

    return (
        <Button
            sx={{textTransform: 'none', color: 'black', border: '1px solid #dadce0'}}
            startIcon={<Icon icon='flat-color-icons:google'/>}
            onClick={() => login()}
        >
            Acceder con Google
        </Button>

    );
};

export default GoogleSignInButton;
